import { useAb } from 'hooks'
import links from 'links'
import { usePathname } from 'router'
import { constants } from 'helpers'
import { queryMultiPlanCoupons } from 'helpers/getters/getCouponFromQueryParams'


const ALLOWED_COUPONS = Object.values(queryMultiPlanCoupons)

export const usePlanSelectSectionVisibility = (couponCode: string) => {
  const pathname = usePathname()

  const isHomePlansAbEnabled = useAb(constants.abTests.homePlansV2) === 'b'

  const isHomePage = (
    pathname === links.home
    || pathname === links.homeMen
  )

  return (
    isHomePage
    && isHomePlansAbEnabled
    && (!couponCode || ALLOWED_COUPONS.includes(couponCode))
  )
}
